import {
  PanelContainer,
  NodePanelProps,
} from "../../lib/panel/panel-container";
import { PanelModifyOrderTags } from "./panel-modify-order-tags";

export function ModifyOrderTagsActionNodePanel(props: NodePanelProps<any>) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelModifyOrderTags />
    </PanelContainer>
  );
}
